const KEY = 'adnz_themeId';
const THEME_VALUE = { primary: '#F2F2F3', primaryDark: '#232325', system: null };
type Theme = keyof typeof THEME_VALUE;

const valueIsTheme = (val: string): val is Theme => Object.keys(THEME_VALUE).includes(val);

function safeGet(key: string): Theme | null {
  try {
    const value = localStorage.getItem(key);
    if (!value) return null;
    if (valueIsTheme(value)) {
      return value;
    }
    return null;
  } catch {
    return null;
  }
}

function safePrefersDark() {
  try {
    const hasMM = typeof window !== 'undefined' && typeof window.matchMedia === 'function';
    const mql = hasMM ? window.matchMedia('(prefers-color-scheme: dark)') : null;
    return !!(mql && mql.matches);
  } catch {
    return false;
  }
}

function loadtheme() {
  const saved = safeGet(KEY);
  const prefersDark = safePrefersDark();
  const id = saved === 'system' ? (prefersDark ? 'primaryDark' : 'primary') : saved || 'primary';

  document.documentElement.setAttribute('data-theme', id);

  let meta: HTMLMetaElement | null = document.querySelector('meta#theme-color-runtime[name="theme-color"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.id = 'theme-color-runtime';
    meta.name = 'theme-color';
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', THEME_VALUE[id] || '#F2F2F3');
}

if (import.meta.env.VITE_LOAD_THEME) {
  loadtheme();
}
